import React from "react";

import { useQuery } from "@apollo/client";

// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from "@material-ui/core/styles";

import Badge from "@material-ui/core/Badge";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
// import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
// import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
// import InputAdornment from "@material-ui/core/InputAdornment";
import InputLabel from "@material-ui/core/InputLabel";
// import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Popover from "@material-ui/core/Popover";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";

import { KeyboardDatePicker } from "@material-ui/pickers";

import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
// import FirstPageIcon from "@material-ui/icons/FirstPage";
// import LastPageIcon from "@material-ui/icons/LastPage";

// import DateRangeIcon from "@material-ui/icons/DateRange";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import * as _ from "lodash";

import { default as datemath } from "@elastic/datemath";

import moment from "moment";
// import * as Moment from "moment";
// import { extendMoment } from "moment-range";

// const moment = extendMoment(Moment);

import { durationSelectVar } from "./apollo-client";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      // margin: theme.spacing(0),
      // paddingLeft: theme.spacing(1),
      // paddingRight: theme.spacing(1),
    },
    formControl: {
      minWidth: "150px",
      margin: theme.spacing(0, 1),
    },
  })
);

const TIMERANGE_QUERY = gql`
  {
    durationSelect @client {
      startDateTouched
      startDate
      endDate
      durationISO
      duration
    }
  }
`;

interface Props {}

// TODO cf. DurationSelect (hal-playground)

function GlobalDatePicker(props: Props) {
  const classes = useStyles(props);
  const theme = useTheme() as Theme;
  const fullWidth = useMediaQuery(theme.breakpoints.down("xs"));
  // const context = useContext(IntervalSelectContext);

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<null | HTMLDivElement>(null);

  // const [selectedDate, setSelectedDate] = React.useState<Date | null>(new Date()/*"<CUSTOM>"*/);
  // const [value, setValue] = useState("1day");

  // function handleOpen(
  //   // event: React.MouseEvent<HTMLElement> | React.FocusEvent<HTMLElement>
  //   index: number
  // ) {
  //   // setAnchorEl(event.currentTarget);
  //   // setAnchorEl(anchorEl ? null : event.currentTarget);
  //   setSelectedIndex(index);
  //   setOpen(true);
  // }

  function handleClose(event: React.MouseEvent<Document>) {
    // if (anchorRef.current && anchorRef.current.contains(event.target)) {
    //   return;
    // }

    setOpen(false);
  }

  const { data, error, loading } = useQuery(TIMERANGE_QUERY);

  const quickItems = [
    // {
    //   id: "-",
    //   name: "None",
    //   interval: undefined
    // },
    {
      id: "today",
      name: "Today",
      interval: {
        startDate: "now/d",
        endDate: "now/d",
      },
      periodDuration: "P1D",
    },
    {
      id: "yesterday",
      name: "Yesterday",
      interval: {
        startDate: "now-1d/d",
        endDate: "now-1d/d",
      },
      periodDuration: "P1D",
    },
    {
      id: "thisWeek",
      name: "This week",
      interval: {
        startDate: "now/w",
        endDate: "now/w",
      },
      periodDuration: "P1W",
    },
    {
      id: "weekToDate",
      name: "Week to date",
      interval: {
        startDate: "now/w",
        endDate: "now/d",
      },
      periodDuration: "P1W",
    },
    {
      id: "thisMonth",
      name: "This month",
      interval: {
        startDate: "now/M",
        endDate: "now/M",
      },
      periodDuration: "P1M",
    },
    {
      id: "monthToDate",
      name: "Month to date",
      interval: {
        startDate: "now/M",
        endDate: "now/d",
      },
      periodDuration: "P1M",
    },
    {
      id: "thisYear",
      name: "This Year",
      interval: {
        startDate: "now/y",
        endDate: "now/y",
      },
      periodDuration: "P1Y",
    },
    {
      id: "yearToDate",
      name: "Year to date",
      interval: {
        startDate: "now/y",
        endDate: "now/d",
      },
      periodDuration: "P1Y",
    },
  ];
  const rangeItems = [
    // {
    //   id: "-",
    //   name: "None",
    //   interval: undefined
    // },
    {
      id: "1day",
      name: "1 Day",
      interval: {
        startDate: "now/d",
        endDate: "now/d",
      },
      periodDuration: "P1D",
    },
    {
      id: "2days",
      name: "2 Days",
      interval: {
        startDate: "now-1d/d",
        endDate: "now/d",
      },
      periodDuration: "P2D",
    },
    {
      id: "1week",
      name: "1 Week",
      interval: {
        startDate: "now-7d/d",
        endDate: "now/d",
      },
      periodDuration: "P7D", // TODO "P1W"
    },
    {
      id: "2weeks",
      name: "2 Weeks",
      interval: {
        startDate: "now-14d/d",
        endDate: "now/d",
      },
      periodDuration: "P14D", // TODO "P2W"
    },
    {
      id: "30days",
      name: "30 Days",
      interval: {
        startDate: "now-30d/d",
        endDate: "now/d",
      },
      periodDuration: "P30D",
    },
    {
      id: "60days",
      name: "60 Days",
      interval: {
        startDate: "now-60d/d",
        endDate: "now/d",
      },
      periodDuration: "P60D",
    },
    {
      id: "90days",
      name: "90 Days",
      interval: {
        startDate: "now-90d/d",
        endDate: "now/d",
      },
      periodDuration: "P90D",
    },
    {
      id: "120days",
      name: "120 Days",
      interval: {
        startDate: "now-120d/d",
        endDate: "now/d",
      },
      periodDuration: "P120D",
    },
    {
      id: "1year",
      name: "1 Year",
      interval: {
        startDate: "now-1y/d",
        endDate: "now/d",
      },
      periodDuration: "P1Y",
    },
    {
      id: "<CUSTOM>",
      name: "Custom",
      interval: {
        startDate: "",
        endDate: "",
      },
      periodDuration: "-",
    },
  ];

  const keyed = _.keyBy([...quickItems, ...rangeItems], "id");
  const keyedByPeriodDuration = _.keyBy([...rangeItems], "periodDuration");
  const isCustom = !(data.durationSelect.durationISO in keyedByPeriodDuration);
  const value = isCustom
    ? "<CUSTOM>"
    : keyedByPeriodDuration[data.durationSelect.durationISO].id;

  // const selectedDurationObject = keyed[value];
  // const selectedDurationObjectSuffix = selectedDurationObject.periodDuration.substring(
  //   1
  // );
  // FIXME Fix usages of selectedDurationObjectSuffix => sometimes PT is needed instead of P
  const selectedDurationObjectSuffix = data.durationSelect.durationISO.substring(
    data.durationSelect.durationISO.startsWith("PT") ? 2 : 1
  );

  const [dateTimeAmount, setDateTimeAmount] = React.useState(
    !!isCustom
      ? parseInt(
          data.durationSelect.durationISO.substring(
            data.durationSelect.durationISO.startsWith("PT") ? 2 : 1,
            data.durationSelect.durationISO.length - 1
          ),
          10
        )
      : 1
  );
  const [dateTimeUnit, setDateTimeUnit] = React.useState(
    !!isCustom
      ? data.durationSelect.durationISO.substring(
          data.durationSelect.durationISO.length - 1,
          data.durationSelect.durationISO.length
        )
      : "D"
  );

  function handleDateTimeAmountChange(event: any) {
    setDateTimeAmount(event.target.value);
  }

  function handleDateTimeUnitChange(event: any) {
    setDateTimeUnit(event.target.value);
  }

  // function startDateFn(
  //   startDate: moment.Moment,
  //   endDate: moment.Moment,
  //   startDateTouched: boolean,
  //   duration: moment.Duration
  // ) {
  //   return !startDateTouched
  //     ? moment(endDate)
  //         .subtract(duration)
  //         .add(1, "second")
  //         .startOf(!!isCustom && dateTimeUnit === "H" ? "hour" : "day")
  //     : startDate;
  // }
  function endDateFn(
    startDate: moment.Moment,
    endDate: moment.Moment,
    startDateTouched: boolean,
    duration: moment.Duration
  ) {
    return !!startDateTouched
      ? moment(startDate)
          .add(duration)
          .subtract(1, "second")
          .endOf(!!isCustom && dateTimeUnit === "H" ? "hour" : "day")
      : endDate;
  }

  // const { startDate, endDate, duration, durationISO } = data;
  //: { startDate, endDate, duration, durationISO }

  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error);
    return <p>Error :(</p>;
  }

  const name = "global-date-picker";

  // function handleDateChange(date: Date | null) {
  //   setSelectedDate(date);
  //   // setSelectedDate(date === null ? "<CUSTOM>" : date.toISOString()); // TODO moment!
  // }

  function handleStartDateChange(date: Date | null) {
    // TODO update durations, etc.
    const startDateTouched = true;
    const startDate = date ? moment(date) : moment();
    const endDate = endDateFn(
      startDate,
      moment(data.durationSelect.endDate),
      startDateTouched,
      moment.duration(data.durationSelect.duration)
    );
    durationSelectVar({
      ...data.durationSelect,
      // __typename: "DurationSelect",
      startDateTouched,
      startDate: startDate.toJSON(),
      endDate: endDate.toJSON(),
    });
  }
  const handleDateRangeSelectChange = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    const durationId = event.target.value;
    // console.log("handleDateRangeSelectChange", durationId);

    if (durationId === "<CUSTOM>") {
      setOpen(true);
      // TODO
      return;
    } else {
      // TODO check this
      setDateTimeAmount(1);
      setDateTimeUnit("D");
    }
    handleDateRangeChange(keyed[durationId]);
  };
  const handleDateRangeChange = (item: any) => {
    const durationISO = item.periodDuration;
    // console.log("handleDateRangeChange", item);
    // TODO also set start/end date from interval!
    const duration = moment.duration(durationISO);
    // console.log("data.durationSelect.", data.durationSelect);
    // const startDate = startDateFn(
    //   moment(data.durationSelect.startDate),
    //   moment(data.durationSelect.endDate),
    //   data.durationSelect.startDateTouched,
    //   duration
    // );
    // const endDate = endDateFn(
    //   startDate,
    //   moment(data.durationSelect.endDate),
    //   data.durationSelect.startDateTouched,
    //   duration
    // );
    // TODO cf. useDateRange
    const interval = item.interval;
    let startDate = moment(
      interval && interval.startDate
        ? datemath.parse(interval.startDate, { momentInstance: moment })
        : data.durationSelect.startDate
    ); //.unix();
    let endDate = moment(
      interval && interval.endDate
        ? datemath.parse(interval.endDate, {
            momentInstance: moment,
            roundUp: true,
          })
        : data.durationSelect.endDate
    ); //.unix();
    // TODO Fix this workaround
    if (!!data.durationSelect.startDateTouched && !isCustom) {
      startDate = moment(data.durationSelect.startDate);
      endDate = endDateFn(
        startDate,
        moment(data.durationSelect.endDate),
        data.durationSelect.startDateTouched,
        duration
      );
    }

    // https://github.com/dangrossman/daterangepicker/blob/master/daterangepicker.js#L491
    //const endDate = !!startDateTouched ? moment(endDate).add(1,"d").startOf("day").subtract(1,"second") : endDate;
    durationSelectVar({
      ...data.durationSelect,
      // __typename: "DurationSelect",
      durationISO,
      duration: duration.toISOString(),
      startDate: startDate.toJSON(),
      endDate: endDate.toJSON(),
    });
    if (localStorage) {
      localStorage.setItem("lastTimeRange", duration.toISOString());
    }
  };

  function handleJumpDate(pd: string) {
    handleStartDateChange(
      moment(data.durationSelect.startDate).add(moment.duration(pd)).toDate()
    );
    // setSelectedDate(moment(selectedDate ? selectedDate : new Date()).add(moment.duration(pd)).toDate());
  }

  // TODO all
  // TODO custom
  return (
    <>
      <Hidden mdDown>
        <ButtonGroup>
          {/* <IconButton className={classes.button} aria-label="Go to Begin">
          <FirstPageIcon />
        </IconButton> */}
          <IconButton
            className={classes.button}
            onClick={() => handleJumpDate("P-30D")}
            aria-label="Go 30 Days back"
          >
            <Badge badgeContent={30}>
              <ChevronLeftIcon />
            </Badge>
          </IconButton>
          <IconButton
            className={classes.button}
            onClick={() => handleJumpDate("P-7D")}
            aria-label="Go 7 Days back"
          >
            <Badge badgeContent={7}>
              <ChevronLeftIcon />
            </Badge>
          </IconButton>
          <IconButton
            className={classes.button}
            onClick={() => handleJumpDate("P-1D")}
            aria-label="Go to Previous day"
          >
            <Badge badgeContent={1}>
              <ChevronLeftIcon />
            </Badge>
          </IconButton>
          <IconButton
            className={classes.button}
            onClick={() => handleJumpDate(`P-${selectedDurationObjectSuffix}`)}
            aria-label={`Go ${keyed[value].name} back`}
          >
            <ChevronLeftIcon />
          </IconButton>
        </ButtonGroup>
      </Hidden>
      <FormControl fullWidth={fullWidth} className={classes.formControl}>
        <KeyboardDatePicker
          // margin="normal"
          id="mui-pickers-date"
          label="Start date"
          // value={selectedDate === "<CUSTOM>" ? null : new Date(selectedDate)}
          value={moment(data.durationSelect.startDate).toDate()}
          onChange={handleStartDateChange}
          KeyboardButtonProps={{
            "aria-label": "change date",
          }}
        />
      </FormControl>
      <Hidden mdDown>
        <ButtonGroup>
          <IconButton
            className={classes.button}
            onClick={() => handleJumpDate(`P+${selectedDurationObjectSuffix}`)}
            aria-label={`Go ${keyed[value].name} forward`}
          >
            <ChevronRightIcon />
          </IconButton>
          <IconButton
            className={classes.button}
            onClick={() => handleJumpDate("P+1D")}
            aria-label="Go to Next day"
          >
            <Badge badgeContent={1}>
              <ChevronRightIcon />
            </Badge>
          </IconButton>
          <IconButton
            className={classes.button}
            onClick={() => handleJumpDate("P+7D")}
            aria-label="Go 7 Days forward"
          >
            <Badge badgeContent={7}>
              <ChevronRightIcon />
            </Badge>
          </IconButton>
          <IconButton
            className={classes.button}
            onClick={() => handleJumpDate("P+30D")}
            aria-label="Go 30 Days forward"
          >
            <Badge badgeContent={30}>
              <ChevronRightIcon />
            </Badge>
          </IconButton>
          {/* <IconButton className={classes.button} aria-label="Go to End">
          <LastPageIcon />
        </IconButton> */}
        </ButtonGroup>
      </Hidden>
      <FormControl fullWidth={fullWidth} className={classes.formControl}>
        <InputLabel htmlFor={name}>Date range</InputLabel>
        <Select
          ref={anchorRef}
          name={name}
          onChange={handleDateRangeSelectChange}
          value={value}
          // IconComponent={DateRangeIcon}
        >
          {/* {quickItems &&
          quickItems.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
          <Divider /> */}
          {rangeItems &&
            rangeItems.map((item: any) => (
              <MenuItem key={item.id} value={item.id}>
                <div
                  onClick={() => {
                    if (item.id === "<CUSTOM>") {
                      setOpen(true);
                    }
                  }}
                >
                  {item.name}
                </div>
              </MenuItem>
            ))}
          {/* <MenuItem key="<CUSTOM>" value="<CUSTOM>">
            Custom
          </MenuItem> */}
        </Select>
      </FormControl>
      <Popover
        // id={id}
        open={open}
        anchorEl={anchorRef.current}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div style={{ margin: theme.spacing(1) }}>
          {/* TODO other units (week, month, year, ...) */}
          <Grid container spacing={1}>
            <Grid item xs={12} md>
              <TextField
                id="datetimeamount"
                label="Amount"
                // defaultValue="1"
                type="number"
                value={dateTimeAmount}
                required
                fullWidth
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // InputProps={{
                //   endAdornment: (
                //     <InputAdornment position="end">Days</InputAdornment>
                //   ),
                // }}
                onChange={handleDateTimeAmountChange}
              />
            </Grid>
            <Grid item xs={12} md>
              <FormControl className={classes.formControl} fullWidth>
                <InputLabel id="datetimeunit-label">Unit</InputLabel>
                <Select
                  labelId="datetimeunit-label"
                  id="datetimeunit"
                  value={dateTimeUnit}
                  onChange={handleDateTimeUnitChange}
                >
                  <MenuItem value={"H"}>Hours</MenuItem>
                  <MenuItem value={"D"}>Days</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                className={classes.button}
                color="primary"
                // type="submit"
                // disabled={submitting || invalid}
                onClick={(e) => {
                  const dateTimeUnitDateMath = dateTimeUnit.toLowerCase();
                  handleDateRangeChange({
                    id: "custom",
                    name: "custom",
                    interval: {
                      startDate: `now-${dateTimeAmount}${dateTimeUnitDateMath}/${dateTimeUnitDateMath}`,
                      endDate: `now/${dateTimeUnitDateMath}`,
                    },
                    periodDuration: `P${
                      dateTimeUnit === "H" ? "T" : ""
                    }${dateTimeAmount}${dateTimeUnit}`,
                  });
                  setOpen(false);
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </div>
      </Popover>
    </>
  );
}

export default GlobalDatePicker;
